import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { HomeComponent } from "./components/home/home.component";
import { LanguageComponent } from "./components/language/language.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { RevenueChartComponent } from "./components/revenue-chart/revenue-chart.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { BuyStakeComponent } from "./modals/buy-stake/buy-stake.component";
import { ClaimComponent } from "./modals/claim/claim.component";
import { ConnectComponent } from "./modals/connect/connect.component";
import { ReferComponent } from "./modals/refer/refer.component";
import { WertComponent } from "./modals/wert/wert.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { RouterModule } from "@angular/router";
import { EventService } from "./services/event.service";
import { NftModule } from "./components/nft/nft.module";
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { LootboxModule } from "./components/lootboxes/lootbox.module";
import { LoginComponent } from "./components/login/login.component";

// Factory function required for AOT compilation
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    BuyStakeComponent,
    ClaimComponent,
    ConnectComponent,
    ReferComponent,
    WertComponent,
    AppComponent,
    LanguageComponent,
    HomeComponent,
    SpinnerComponent,
    RevenueChartComponent,
    SidebarComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LottieModule.forRoot({ player: playerFactory }),
    NgxIntlTelInputModule,
    LootboxModule,
    NftModule,
  ],
  providers: [DatePipe, EventService],
  bootstrap: [AppComponent],
  exports: [
  ],
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
